var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"provider-list-page"},[(_vm.loading)?_c('div',{staticClass:"loading-placeholder"},[_c('loading-symbol')],1):(_vm.noDataFound)?_c('no-data-message'):_c('provider-list-view',{attrs:{"providers":_vm.providers}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }